/**
 * @flow
 * @relayHash 1310db2911605b1e050d9a0edfa64476
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailSalesOrderInput = {|
  orderId: string
|};
export type EmailSalesOrderMutationVariables = {|
  input: EmailSalesOrderInput
|};
export type EmailSalesOrderMutationResponse = {|
  +emailSalesOrder: {|
    +success: boolean
  |}
|};
export type EmailSalesOrderMutation = {|
  variables: EmailSalesOrderMutationVariables,
  response: EmailSalesOrderMutationResponse,
|};
*/


/*
mutation EmailSalesOrderMutation(
  $input: EmailSalesOrderInput!
) {
  emailSalesOrder(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailSalesOrderInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailSalesOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailSalesOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailSalesOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailSalesOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailSalesOrderMutation",
    "id": null,
    "text": "mutation EmailSalesOrderMutation(\n  $input: EmailSalesOrderInput!\n) {\n  emailSalesOrder(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7408a1645960967d9518422a106f9fb1';
module.exports = node;
